import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {PostAuthRequest, PostAuthRequestModel, PostAuthRequestParams} from 'domain/usecases';

export class RemotePostAuthRequest implements PostAuthRequest {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostAuthRequestModel>,
	) {}

	async post(params: PostAuthRequestParams): Promise<PostAuthRequestModel> {
		const {signal, ...restParams} = params || {};

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: restParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
